<template>
  <v-container style="height: 100%;" pt-7 px-6 ma-0 fluid>
    <v-row no-gutters>
      <v-col>
        <v-card style="border-radius: 20px;" class="white">
          <v-card-title class="header-border pa-0 ma-0">
            <v-row class="ml-0" no-gutters align="start" justify="start" style="width: 0px">
              <v-col cols="auto">
                <div :style="cssProps" class="default-tabs__item">PENDÊNCIA</div>
              </v-col>
              <div class="lineHeader"></div>
            </v-row>
          </v-card-title>
          <v-card-text class="mt-10">
            <PendenciaTable 
              @visualizar="objetoPendente => visualizarModal(objetoPendente)" 
              :carregar="carregarTable" 
              @carregou="value => $emit('carregouTable', value)"
              @anexo="openAnexo" 
            />
          </v-card-text>
          <v-card-actions class="mx-4" style="border-top: 1px solid #9E9E9E80">
            <v-row align="center" justify="end">
              <v-col cols="12" sm="auto">
                <button-cadu
                  text="VOLTAR"
                  :block="$vuetify.breakpoint.xs"
                  :backColor="$vuetify.theme.themes.light.primary2"
                  @click="$router.push('/home')"
                />
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <ModalAnexo
            v-model="showAnexo"
            ref="anexo"
    />
  </v-container>
</template>

<script>
import PendenciaTable from './TablePendencia'
import ModalAnexo from './ModalAnexo'


export default {
  components: {
    PendenciaTable,
    ModalAnexo
  },

  props: {
    carregarTable: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data () {
    return {
      greenColor: this.$vuetify.theme.themes.light.primary1,
      greyColor: '#9E9E9E',
      show: false,
      showAnexo: false
    }
  },
  computed: {
    cssProps () {
      return {
        color: this.greenColor
      }
    }
  },

  methods: {
    visualizarModal (objeto) {
      this.$emit('showPendencia', objeto)
    },
    openAnexo (id) {
      this.showAnexo = true
      this.$refs.anexo.start(id)
    }
  }
}
</script>

<style lang="sass">

.lineHeader
  border-top: 1px solid #9E9E9E80
  // border: 2px solid #00995d
  //border: 2px solid #dee2e6
  width: 100%

.default-tabs__item
  margin: 0
  font-weight: 800
  padding-bottom: 0px
  padding-top: 12px
  padding-left: 12px
  padding-right: 12px
  font-size: 16px
  letter-spacing: 0.8px
  text-decoration: none
  border: none
  background-color: transparent
  //border-bottom: 2px solid transparent
  cursor: pointer
  transition: all 0.25s
  @media screen and (max-width: 920px)
    font-size:10px
  @media screen and (max-width: 1050px)
    font-size:14px
</style>
